export const FREEMIUM_TEACHER_LIMIT = 10

export const FREEMIUM_TEACHER_LIMIT_MESSAGE = 'Upgrade your pack to add more teachers.'

export function extractPlanNameFromAvailableServices(res: unknown): string | null {
  const plan = (res as {result?: {payload?: {subscription_info?: {plan_name?: string}}}})?.result
    ?.payload?.subscription_info?.plan_name
  return typeof plan === 'string' && plan.trim() ? plan.trim() : null
}

export function isFreemiumPlanName(planName: string | null | undefined): boolean {
  return planName?.trim().toLowerCase() === 'freemium'
}
